// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tile-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  height: 40px;
}
.tile {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  border-right: 1pt solid #d0d5dd
}
.tile:hover {
    cursor: pointer;
    background-color: #f5f5f5;
  }
.tile:last-child {
    border-right: none;
  }
.tile.highlight-gray {
    background-color: #f5f5f5;
  }
.tile.highlight-darkgray {
    background-color: #f0f0f0;
  }
.tile.highlight-purple {
    background-color: #ece3f2;
    color: #590b8a;
  }
.button {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  font-size: 14px;
  border-radius: 8px;
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  justify-content: center
}
.button:hover {
    cursor: pointer;
    background-color: #f5f5f5;
    color: black;
  }
.button__clear:hover {
      background-color: white;
    }
.button__white {
    background: white;
    border: 1.5px solid #eaecf0;
  }
.button__white--clicked {
      /* box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05); */
    }
.button__lightPurple {
    background: #ece3f2;
    color: #590b8a;
    border: 1.5px solid #a67bc3;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  }
.button__darkPurple {
    background: #590b8a;
    border: 1px solid #590b8a;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    color: white
  }
.button__darkPurple:hover {
      background: #7c39a6;
      color: white;
    }
.button__darkPurple--clicked {
      /* background: #590b8a;
      color: white; */
    }
.button__red {
    background: #d92d20;
    color: white
  }
.button__red:hover {
      background: black;
      color: white;
    }
.button__green {
    background: #079455;
    color: white
  }
.button__green:hover {
      background: black;
      color: white;
    }

.nohover:hover {
  background: inherit !important;
  cursor: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tiles.pcss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ;AAuBF;AArBE;IACE,eAAe;IACf,yBAAyB;EAC3B;AAEA;IACE,kBAAkB;EACpB;AAEA;IACE,yBAAyB;EAC3B;AAEA;IACE,yBAAyB;EAC3B;AAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;AAEF;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ;AAyDF;AAxDE;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;EACd;AAGE;MACE,uBAAuB;IACzB;AAEF;IACE,iBAAiB;IACjB,2BAA2B;EAI7B;AAHE;MACE,wDAAwD;IAC1D;AAEF;IACE,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,kDAAkD;EACpD;AACA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kDAAkD;IAClD;EASF;AARE;MACE,mBAAmB;MACnB,YAAY;IACd;AACA;MACE;qBACe;IACjB;AAEF;IACE,mBAAmB;IACnB;EAMF;AAJE;MACE,iBAAiB;MACjB,YAAY;IACd;AAEF;IACE,mBAAmB;IACnB;EAMF;AAJE;MACE,iBAAiB;MACjB,YAAY;IACd;;AAIJ;EACE,8BAA8B;EAC9B,uBAAuB;AACzB","sourcesContent":["$midDesktop: 990px;\n\n.tile-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  height: 40px;\n}\n.tile {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  font-size: 14px;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n  border-right: 1pt solid #d0d5dd;\n\n  &:hover {\n    cursor: pointer;\n    background-color: #f5f5f5;\n  }\n\n  &:last-child {\n    border-right: none;\n  }\n\n  &.highlight-gray {\n    background-color: #f5f5f5;\n  }\n\n  &.highlight-darkgray {\n    background-color: #f0f0f0;\n  }\n\n  &.highlight-purple {\n    background-color: #ece3f2;\n    color: #590b8a;\n  }\n}\n.button {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  font-size: 14px;\n  border-radius: 8px;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 100%;\n  justify-content: center;\n  &:hover {\n    cursor: pointer;\n    background-color: #f5f5f5;\n    color: black;\n  }\n\n  &__clear {\n    &:hover {\n      background-color: white;\n    }\n  }\n  &__white {\n    background: white;\n    border: 1.5px solid #eaecf0;\n    &--clicked {\n      /* box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05); */\n    }\n  }\n  &__lightPurple {\n    background: #ece3f2;\n    color: #590b8a;\n    border: 1.5px solid #a67bc3;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n  }\n  &__darkPurple {\n    background: #590b8a;\n    border: 1px solid #590b8a;\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    color: white;\n    &:hover {\n      background: #7c39a6;\n      color: white;\n    }\n    &--clicked {\n      /* background: #590b8a;\n      color: white; */\n    }\n  }\n  &__red {\n    background: #d92d20;\n    color: white;\n\n    &:hover {\n      background: black;\n      color: white;\n    }\n  }\n  &__green {\n    background: #079455;\n    color: white;\n\n    &:hover {\n      background: black;\n      color: white;\n    }\n  }\n}\n\n.nohover:hover {\n  background: inherit !important;\n  cursor: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
